export type ClientsQueryParams = {
  identifier: string
  teamId: string
}

export const clientsQueryKeys = {
  get: (params: { teamId: string }) => ['clients', params] as const,
  getByIdentifier: ({ identifier, ...params }: ClientsQueryParams) =>
    [`clients/${identifier}`, params] as const
}

export const clientsMutationKeys = {
  putClientsActivate: ({ identifier, ...params }: ClientsQueryParams) =>
    [`clients/${identifier}/activate`, params] as const,
  delete: ({ identifier, ...params }: ClientsQueryParams) =>
    [`clients/${identifier}`, params] as const
}
